import { useTranslation } from '../../../../../utils/useTranslation';
import { Typography } from '../../../../typography/Typography';

export const StatisticInfo = () => {
    const t = useTranslation();

    return (
        <Typography variant="body">
            {t(
                'В статистике собраны основные метрики, которые позволяют оценивать активность аудитории и выстраивать эффективную стратегию продвижения: охват, показы, реакции и другие. В каждой строке изменения отображаются в относительных и абсолютных показателях.',
            )}
        </Typography>
    );
};
